import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 120000 });

export const fetchScanner  = () => client.get("/scanner/latest").then(r => r.data);
export const rescanNow     = () => client.post("/scanner/rescan").then(r => r.data);
export const fetchBacktest = () => client.get("/backtest/summary").then(r => r.data);
export const rerunBacktest = () => client.post("/backtest/rerun").then(r => r.data);
export const fetchStockBacktest = (symbol) => client.get(`/backtest/stock/${symbol}`).then(r => r.data);
export const fetchConfig = () => client.get("/config").then(r => r.data);

export const fetchAlertsStatus = () => client.get("/alerts/status").then(r => r.data);
export const saveAlertsSettings = (token, chat_id) => client.post("/alerts/settings", { token, chat_id }).then(r => r.data);
export const deleteAlertsSettings = () => client.delete("/alerts/settings").then(r => r.data);
export const sendTestAlert = () => client.post("/alerts/test").then(r => r.data);
export const sendAlertSummary = () => client.post("/alerts/send-summary").then(r => r.data);
export const fetchAlertsLog = () => client.get("/alerts/log").then(r => r.data);
export const fetchScannerToday = () => client.get("/scanner/today").then(r => r.data);
export const sendEodDigest = () => client.post("/alerts/send-eod").then(r => r.data);

export const fetchChartinkSettings = () => client.get("/chartink/settings").then(r => r.data);
export const saveChartinkSettings = (scanner_url) => client.post("/chartink/settings", { scanner_url }).then(r => r.data);
export const fetchChartinkDashboard = () => client.get("/chartink/dashboard").then(r => r.data);
export const chartinkScanNow = () => client.post("/chartink/scan-now").then(r => r.data);
export const chartinkCheckNow = () => client.post("/chartink/check-now").then(r => r.data);
export const chartinkClearWatchlist = () => client.delete("/chartink/watchlist").then(r => r.data);
export const chartinkHistory = (days = 7) => client.get(`/chartink/history?days=${days}`).then(r => r.data);
export const fetchChartinkScanners = () => client.get("/chartink/scanners").then(r => r.data);
export const addChartinkScanner = (payload) => client.post("/chartink/scanners", payload).then(r => r.data);
export const updateChartinkScanner = (slug, payload) => client.patch(`/chartink/scanners/${slug}`, payload).then(r => r.data);
export const deleteChartinkScanner = (slug) => client.delete(`/chartink/scanners/${slug}`).then(r => r.data);
